import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { customFieldsService } from '../api/custom-fields.service';
import { CUSTOM_FIELD_KEYS } from './queryKeys';
import type { CreateFieldInput, UpdateFieldInput } from '../schemas';

export function useCreateProjectField(projectId: string) {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (payload: CreateFieldInput) =>
      customFieldsService.createProjectField(projectId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CUSTOM_FIELD_KEYS.byProject(activeOrganizationId ?? '', projectId),
      });
    },
  });
}

export function useUpdateProjectField(projectId: string) {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: ({ fieldId, payload }: { fieldId: string; payload: UpdateFieldInput }) =>
      customFieldsService.updateProjectField(projectId, fieldId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CUSTOM_FIELD_KEYS.byProject(activeOrganizationId ?? '', projectId),
      });
    },
  });
}

export function useDeleteProjectField(projectId: string) {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (fieldId: string) => customFieldsService.deleteProjectField(projectId, fieldId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CUSTOM_FIELD_KEYS.byProject(activeOrganizationId ?? '', projectId),
      });
    },
  });
}
